const sidebarFiltersSg = (()=> {
  document.addEventListener('DOMContentLoaded',() => {
    const superGroupContainer = document.querySelector('.sf-btns-container');
    if (superGroupContainer) {
      sidebarFiltersSg.init();
    }
  });

  return {
    init: () => {
      sidebarFiltersSg.sg =sidebarFiltersSg.parseRsUrl('sg');
      sidebarFiltersSg.acts = sidebarFiltersSg.parseRsUrl('act');
      sidebarFiltersSg.labels = sidebarFiltersSg.parseRsUrl('label');
      const seeLess = document.querySelector('.js-sf-sg-see-less-toggle');
      const breadcrumbsContainer = document.querySelector('.nav-banner-breadcrumbs');
      const sgBtns = document.querySelectorAll('.sf-btns-container .js_sf_superGroup');
      const destExpanders = document.querySelectorAll('.js-sf_filter_group_3_expander');

      if (breadcrumbsContainer) {
        sidebarFiltersSg.initNavBarBreadcrumbs(breadcrumbsContainer, sidebarFiltersSg.acts);
      }      

      if (!!sgBtns.length) {
        sgBtns.forEach(btn => {
          if (sidebarFiltersSg.sg == btn.dataset.sg) {
            btn.classList.add('selected');
          }
          btn.addEventListener('click', (e) => {
            if (window.location.search.includes('act=')) {
              window.location.search = sidebarFiltersSg.setBackUrl(['act', 'label']);
            } else {
              const sgId = btn.dataset.sg;
              if (+sgId < 4 || +sgId == 5) {
                changeMultipleParams(e, [`sg=${sgId}`, 'online_offer=false', 'day_activity=false'], ['online_offer=', 'sg=', 'day_activity=']);
              }
            }
          })
        })
      }

      sidebarFiltersSg.toggleSeeLess(seeLess);
      if (sidebarFiltersSg.sfLevel > 1) {
        sidebarFiltersSg.initSubLabelsGroups(seeLess);
        if (sidebarFiltersSg.sfLevel > 2) {
          sidebarFiltersSg.initSubLabels();
        }
      }

      sidebarFiltersSg.initResetBtn(sidebarFiltersSg.acts);

      const coActSubLabelsBtns = document.querySelectorAll('#sf_core_activities_sub_filters_with_sg .sf-collapse-btn');
      if (coActSubLabelsBtns && !!coActSubLabelsBtns.length) {
        coActSubLabelsBtns.forEach(btn => {
          btn.addEventListener('click', (e) => {
            sidebarFiltersSg.expandList(btn);
          });
        })
      }

      seeLess?.addEventListener('click', (e) => {
        sidebarFiltersSg.toggleSeeLess(seeLess);
      })

      destExpanders.forEach(dexp => {
        dexp.addEventListener('click', e => {
          sidebarFiltersSg.getDestChildrenList(e);
        });
      });

      const stylesHandlers = document.querySelectorAll('.sl-hdl');
      if (stylesHandlers && stylesHandlers.length > 0) {
        stylesHandlers.forEach(styleHandler => {
          sidebarFiltersSg.toggleStyleList(styleHandler);
        });
      }
    },

    initSubLabelsGroups: () => {
      const subLabel = document.querySelector('#sf_core_activities_sub_filters_with_sg');

      if (subLabel?.querySelector('.sf-collapse-btn')) {
        subLabel.parentElement.classList.remove('hide');
      }
      if (sidebarFiltersSg.sfLevel > 1 && sidebarFiltersSg.acts.length) {
        if (sidebarFiltersSg.sfLevel > 2 && !subLabel.querySelector('.sf-exp-styles-list.active')) {
          subLabel.querySelectorAll('.sf-exp-styles-list.disabled').forEach(subLabelDis => {
            if (sidebarFiltersSg.acts.includes(subLabelDis.dataset.coActId)) {
              subLabelDis.classList.remove('hide');
            }
          });
        }
      }
    },

    initSubLabels: () => {
      const coActSubLabelsWrapper = document.querySelector('#sf_core_activities_sub_filters_with_sg');

      coActSubLabelsWrapper?.querySelectorAll('.sf-exp-styles-list .sf-sub-scrollbar').forEach(list => {
        if (!!list.querySelectorAll('ul li.selected').length) {
          list.previousElementSibling?.querySelector('.subtitle-text').insertAdjacentHTML('beforeend', `<span>${list.querySelectorAll('ul li.selected').length}</span>`);
        }
      });
    },

    initNavBarBreadcrumbs: (container, actsList) => {
      const acts = [];

      // get all selected core activities names
      if (actsList && actsList.length) {
        actsList.forEach((act, i) => {
          const activity = document.querySelector(`.js_sf_co_act_list li[data-core-activity="${act}"]`);
          if (!activity) { i++; }
          else if (actsList.length < 3) {
            const activityName = activity?.dataset.coreActivityName;
            if (activityName) {
              acts.push(activityName);
            }
          } else if (i == 0) {
            const firstActivity = document.querySelector(`.js_sf_co_act_list li[data-core-activity="${act}"]`)?.dataset.coreActivityName;
            if (firstActivity) {
              acts.push(`${firstActivity} & Other`);
            }
          }
        });
      }
  
      // Construct the breadcrumbs HTML
      const breadcrumbsHtml = `
          ${sidebarFiltersSg.sfLevel > 1 ? `<li> > ${acts.join(' & ')}</li>` : ''}`;
  
      // Insert the breadcrumbs HTML and add event listener for navigation
      container.insertAdjacentHTML('beforeend', breadcrumbsHtml);
      for (let i = 0; i < container.children.length; i++) {
        const li = container.children[i];
        li.addEventListener('click', (e) => {
          switch (i) {
            case 0:
              sidebarFiltersSg.breadcrumbsBackBtnClick();
              break;
            case 1:
              window.location.search = ''
              break;
            case 2:
              window.location.search = sidebarFiltersSg.setBackUrl(['act', 'label']);
              break;
          }
        })
      }
    },

    initResetBtn: (actList) => {
      const resetBtn = document.querySelector('.btn.reset-btn');
      const toBeRemoved = actList && !!actList.length ? ['act', 'label'] : ['sg', 'online_offer', 'day_activity'];
      resetBtn?.addEventListener('click', (event) => {
        window.location.search = sidebarFiltersSg.setBackUrl(toBeRemoved);
      });
    },

    setBackUrl: (params) => {
      const searchUrl = window.location.search.split('&').filter(s => !s.includes('page'));
      const reset = [];
      searchUrl.forEach(s => {
        if (s.includes('=')) {
          const arr = s.replace('?', '').split('=');
          params.includes(arr[0]) ? null : reset.push(s);
        }
      });
      return reset.join('&');
    },

    breadcrumbsBackBtnClick: () => {
      sidebarFiltersSg.sfLevel--;

      switch (sidebarFiltersSg.sfLevel) {
        case 0:
          window.location.search = sidebarFiltersSg.setBackUrl(['sg', 'online_offer', 'act', 'label']);
          break;
        case 1:
          window.location.search = sidebarFiltersSg.setBackUrl(['act', 'label']);
          break;
        case 2:
          window.location.search = sidebarFiltersSg.setBackUrl(['label']);
          break;
      } 
    },

    expandList: (btn) => {
      const sfSubLabels = btn.nextElementSibling;
      const slHandler = sfSubLabels?.nextElementSibling;
      const isCollapsed = btn.lastElementChild.classList.contains('ebs-icon-arrow-down');
      
      btn.classList.toggle('selected');
      sfSubLabels.classList.toggle('with-scrollbar');
      sfSubLabels.firstElementChild.classList.toggle('collapsed');
      btn.lastElementChild.classList.replace(`ebs-icon-arrow-${isCollapsed ? 'down' : 'up'}`, `ebs-icon-arrow-${isCollapsed ? 'up' : 'down'}`);
      slHandler?.classList.toggle('hide');
    },

    toggleStyleList: (styleHandler) => {
      const styleList = styleHandler.previousElementSibling;
      styleHandler.childNodes.forEach((handler, i) => {
        handler.addEventListener('click', (e) => {
          styleList.scrollTo(0, 0);
          styleList.classList.toggle('l-show-more');

          styleHandler.querySelectorAll('.btn').forEach(btn => {btn.classList.toggle('hide');});
        });
      });
    },

    parseRsUrl: (filter) => {
      const searchParams = new URLSearchParams(window.location.search);
      const filteredParams = [];

      // Collect all instances of the filter in the query params
      for (const [key, value] of searchParams.entries()) {
          if (key === filter) {
              filteredParams.push(value);
          }
      }

      if (!filteredParams.length) return 0;

      // Handle different cases based on the filter
      switch (filter) {
          case 'sg':
              sidebarFiltersSg.sfLevel = 1;
              return filteredParams[0]; // Return the only one 'sg' value 1, 2, 3, 4...
          case 'act':
              sidebarFiltersSg.sfLevel = 2;
              return filteredParams;    // Return all 'act' values [...]
          case 'label':
              sidebarFiltersSg.sfLevel =  sidebarFiltersSg.sfLevel > 1 ? 3 : 1;
              return filteredParams;    // Return all 'label' values [...]
          default:
              return;
      }
    },

    toggleSeeLess: (seeLessElement) => {
      if (!seeLessElement) return;

      const showLength = 10;

      seeLessElement.classList.toggle('collapsed');

      const listContainer = seeLessElement.previousElementSibling;
      if (!listContainer) return;

      const listItems = listContainer.querySelectorAll('li');
      const isLeveledUp = sidebarFiltersSg.sfLevel > 1;

      let selectedGroupNames = [];

      if (isLeveledUp) {
        const selectedItems = document.querySelectorAll('.js_sf_co_act_list li.selected');
        selectedGroupNames = Array.from(selectedItems).map(item => item.dataset.caGroupName);
      }

      if (listItems.length > showLength) {
        listItems.forEach((item, i) => {
          const shouldHide =
            isLeveledUp
              ? item.dataset.caGroupName && !selectedGroupNames.includes(item.dataset.caGroupName)
              : i > showLength - 1;
  
          if (shouldHide) {
            item.classList.toggle('hidden');
          }
        });
      } else {
        seeLessElement.remove();
      }
    },

    getDestChildrenList: (e) => {
      const destParent = e.target.closest('[data-id]');
      const {id, slug, transtagDestinationWithPreposition} = destParent.dataset;
      destParent.classList.toggle('selected');
      if (e.target.classList.contains('sf-lvl2-with-arrow')) {
        changeMultipleParams(e, [`d=${slug}`, 'online_offer=false'], ['d=', 'online_offer=']);
      }
      const search = window.location.search.includes('?') ? window.location.search : '?' + window.location.search;
      const url = '/subdestinations' + search + `&did=${id}`;
      
      const param = {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      };
      if (!destParent.querySelector('.sf_filter_group_3')) {
        fetch(url, param)
        .then(res => res.json())
        .then(response => {
          if (!destParent.querySelector('.sf_filter_group_3')) {
            const {destinations} = response;
            if (!!destinations.length) {
              const ul = `<ul class="sf_filter_group_3">
                <li class="fakeRadio-v1" onClick="changeMultipleParams(event, ['d=${slug}', 'online_offer=false'], ['d=', 'online_offer='])"><a>${transtagDestinationWithPreposition}</a></li>
                ${sidebarFiltersSg.renderDestList(destinations)}
              </ul>`;
              destParent.insertAdjacentHTML('beforeend', ul);
            }
          }
        });
      }

    },

    renderDestList: (destinations) => {
      let destList = '';
      destinations.forEach(dest => {
        destList += `<li class="fakeRadio-v1" onClick="changeMultipleParams(event, ['d=${dest.slug}', 'online_offer=false'], ['d=', 'online_offer='])">
          <a>${dest.name}</a></li>`;
      })
      return destList;
    }
  }
})();